import React from "react";
import blog_push from "../media/blog_push380.png";
import arrow from "../media/arrow.svg";
import "./Blog.css";
import useScrollReveal from "../hooks/useScrollReveal";

const posts = [
  {
    slug: "/blog/radiology-viewer",
    title: "Building a Cloud-Based Radiology Viewer for Healthcare Providers",
    excerpt:
      "How we built a HIPAA-compliant, cloud-native DICOM viewer on AWS, reducing image load times by 70%.",
    date: "March 2024",
    tag: "Healthcare",
    image: null,
  },
  {
    slug: "/blog/push-ads",
    title: "Understanding Push Ads: Their Mechanics and Impact",
    excerpt:
      "Push ads seamlessly blend into user interfaces, offering a discrete yet prominent advertising solution.",
    date: "November 2023",
    tag: "Marketing",
    image: blog_push,
  },
];

export default function Blog() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="blog-block reveal">
      <h1>Blog</h1>
      <div className="blog-block-content">
        {posts.map((post) => (
          <div className="blog-element" key={post.slug}>
            {post.image ? (
              <div
                className="image"
                style={{ backgroundImage: `url(${post.image})` }}
              />
            ) : (
              <div
                className="image"
                style={{ background: "var(--gradient-brand)" }}
              />
            )}
            <div className="reading-time">{post.tag}</div>
            <div className="article-name">{post.title}</div>
            <div className="article-description">{post.excerpt}</div>
            <div className="article-date">{post.date}</div>
            <a href={post.slug} className="read-more">
              Read more
              <img alt="" src={arrow} className="read-more-arrow" />
            </a>
          </div>
        ))}
        <a href="/blog" className="blog-view-all">
          View all posts
          <img alt="" src={arrow} className="read-more-arrow" />
        </a>
      </div>
    </div>
  );
}
